export default {"href":"/corgi/pageapps/purchase/_next/public/sprite-3.45.0-30c130124.svg#marketplace","viewBox":"0 0 40 40"}